// Details of a space clicked in the 3D scene. Clicking never acts by itself; when the space
// is an option of your pending (non-action) decision the panel offers an explicit button for it.
// Actions, moving included, are only taken from the action panel.
import { motion } from "framer-motion";

import * as uf from "../../../../common/unfathomable";
import { CardTip } from "./CardFace";
import { DragPanel } from "./DragPanel";
import { Rich } from "./RichText";
import { spaceDescription } from "./spaceInfo";
import css from "./Unfathomable.module.css";

const kKindZh: Record<uf.SpaceKind, string> = { water: "水域", deck: "甲板", interior: "室内" };

export function SpaceInfoPanel({ view, sp, onClose, onAnswer }: {
  view: uf.GameView;
  sp: uf.SpaceId;
  onClose: () => void;
  onAnswer: (choice: string[]) => void;
}) {
  const info = uf.kSpaces[sp];
  const s = view.spaces[sp];
  const here = view.players.filter(p => p.space === sp);
  const monarchs = (["hydra", "dagon"] as const).filter(m => view[m] === sp);
  const d = view.decision;
  // Actions (moving included) are taken from the action panel only, never from here.
  const options = d?.mine && d.kind !== "action" && d.min === 1 && d.max === 1 ? d.options.filter(o => o.space === sp) : [];
  return (
    <motion.div className={css.spaceInfoPos} initial={{ opacity: 0, x: 30 }} animate={{ opacity: 1, x: 0 }}>
    <DragPanel className={`${css.spaceInfo} ${css.frame}`}>
      <div className={css.spaceInfoHead}>
        <div>
          <div className={css.spaceInfoTitle}>{uf.spaceName(sp)}</div>
          <div className={css.spaceInfoSub}>{kKindZh[info.kind]}{info.numbers.length ? ` · 骰值 ${info.numbers.join("、")}` : ""}</div>
        </div>
        <button className={`${css.btn} ${css.btnSmall} ${css.btnGhost}`} onClick={onClose}>✕</button>
      </div>
      <div className={css.spaceInfoText}>{spaceDescription(sp).split("\n").map((l, i) => <div key={i}><Rich text={l} /></div>)}</div>
      {s.damage && (
        <div className={css.spaceInfoDamage}>
          <b>⚠ 已受损</b>
          <CardTip kind="damage" id={s.damage} />
        </div>
      )}
      <div className={css.spaceInfoList}>
        {here.length > 0 && <div>角色：{here.map(p => `${p.name}（${uf.kCharacters[p.character].name}）`).join("、")}</div>}
        {s.deepOnes > 0 && <div>深潜者：{s.deepOnes}</div>}
        {s.passengers > 0 && <div>乘客：{s.passengers}</div>}
        {monarchs.map(m => <div key={m}>{m === "hydra" ? "母神海德拉在这里" : "父神大衮在这里"}</div>)}
        {here.length === 0 && s.deepOnes === 0 && s.passengers === 0 && monarchs.length === 0 && <div style={{ opacity: 0.7 }}>空无一人。</div>}
      </div>
      {options.length > 0 && (
        <div className={css.spaceInfoActions}>
          {options.map(o => (
            <button key={o.id} className={css.btn} onClick={() => { onAnswer([o.id]); onClose(); }}><Rich text={o.label} /></button>
          ))}
        </div>
      )}
    </DragPanel>
    </motion.div>
  );
}
